import { useState, useEffect } from "react";
import css from "./index.module.css";
import { convertDate } from "../../services/luxonHelper";
import IconComponent from "../icons";

function TimerComponent() {
  const [time, setTime] = useState();

  useEffect(() => {
    setTime(date());
    const interval = setInterval(() => {
      setTime(date());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const date = () => {
    const date = convertDate(new Date(), "dateForPortalDashboard");
    return date;
  };

  return (
    <>
      {time && (
        <>
          <IconComponent name="Clock" className="h-9" />
          <div className={css.portalTime}>
            <span className={css.timeText}>{time.time}</span>
            <span className={css.timeZone}>UTC {time.timeZone}</span>
          </div>
        </>
      )}
    </>
  );
}

export default TimerComponent;
